import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { TrustPilotComponent } from '../../trust-pilot/trust-pilot.component';

@Component({
  selector: 'app-common-subproducts-customer-story',
  templateUrl: './customer-story.component.html',
  styleUrls: ['./customer-story.component.scss'],
  imports: [CommonModule, ToHtmlPipe, TrustPilotComponent],
})
export class CommonSubProductsCustomerStoryComponent implements OnInit {
  @Input() storyData: any;
  @Input() customClass: any;
  constructor() {}
  _storyData: any;
  ngOnInit(): void {
    this._storyData = this.storyData;
  }
  ngOnChanges(): void {
    this._storyData = {
      quoteText: this.storyData?.description,
      name: this.storyData?.name,
      designation: this.storyData?.designation,
      achievement:
        this.storyData?.productsUsedComponent?.[0]?.fields?.textContent,
      achievementTitle:
        this.storyData?.productsUsedComponent?.[0]?.fields?.title,
      imageUrl:
        this.storyData?.productsUsedComponent?.[0]?.fields?.images[0].fields
          ?.file?.url,
    };
  }
}
